import { CommonModule, NgIf } from '@angular/common';
import { Inject, Component, ElementRef, Renderer2} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import * as JS from "../job-post.service";
import { MediaAPIService } from '../../media/media.service';
import { UserInfoService } from '../../user/user-info.service';
import { UtilityModule } from '../../utility/utility.module';

@Component({
	selector: "app-my-job-application-offer",
	templateUrl: "./my-job-application-offer.component.html",
	styleUrls: ["../../base/css/file-upload.scss"],
	standalone: true,
	imports: [CommonModule, NgIf, UtilityModule]
})
export class JobPostApplicantOfferComponent {
	jobPostId: string = "";
	personId: string = "";
	canOffer: boolean = false;

	public offer: JS.IJobApplicantOffer = null;
	public fileIcon: string = "";
	
	public downloadingOffer: boolean = false;
	public replyingOffer: boolean = false;

	public cancelOffer(e: any): void {
		this.dialogRef.close(null);
	}

	public acceptOffer(e: any): void {
		if (!this.canOffer) {
			return;
		}
		Swal.fire({
			title: "Confirm Your Decision",
			text: "You're about to accept the offer for " + this.offer.JobTitle + ". This will notify the employer",
			icon: "success",
			allowOutsideClick: false,
			showCancelButton: true,
			cancelButtonText: "Cancel",
			confirmButtonText: "Confirm",
			reverseButtons: true
		}).then((choice: any) => {
			if (choice.isConfirmed) {
				this.jobAPI.updateOffer(this.jobPostId, this.offer.OfferId, true).subscribe({
					next: () => {
						this.dialogRef.close(null);
					},
					error: (err: any) => {
						Swal.fire("Offer", "Fail to update, please retry.", 'error');
					}
				});
			}
		});
	}

	public declineOffer(e:any): void {
		if (!this.canOffer) {
			return;
		}
		Swal.fire({
			title: "Confirm Your Decision",
			text: "You're about to decline the offer for " + this.offer.JobTitle + ". This will notify the employer",
			icon: "warning",
			allowOutsideClick: false,
			showCancelButton: true,
			cancelButtonText: "Cancel",
			confirmButtonText: "Confirm",
			reverseButtons: true
		}).then((choice: any) => {
			if (choice.isConfirmed) {
				this.jobAPI.updateOffer(this.jobPostId, this.offer.OfferId, false).subscribe({
					next: () => {
						this.dialogRef.close(null);
					},
					error: (err: any) => {
						Swal.fire("Offer", "Fail to update, please retry.", 'error');
					}
				});
			}
		});
	}


	downloadAttachment(e: any): void {
		this.jobAPI.downloadOfferAttachment(this.jobPostId, this.personId, this.offer.OfferId).subscribe({
			next: (attachment: any) => {
				let urlObject = URL.createObjectURL(attachment);
				let downloadLink = this.renderer.createElement('a');
				downloadLink.setAttribute("style", "display:none");
				downloadLink.setAttribute("href", urlObject);
				downloadLink.setAttribute("download", this.offer.Filename);
				this.renderer.appendChild(this.elementRef.nativeElement, downloadLink);
				downloadLink.click();
				// cleanup
				downloadLink.remove();
				URL.revokeObjectURL(urlObject);
			},
			error: (err: any) => {
				console.log(err);
			}
		});
	}

	private getFileIcon(): void {
		let fileNameParse: string[] = this.offer.Filename.split(".");
		let ext: string = fileNameParse.length > 1 ? fileNameParse[fileNameParse.length - 1] : "";
		if (ext.length === 0) {
			ext = "unknown";
		}
		this.fileIcon = this.mediaAPI.getIcon(ext, 24);
	}

	private downloadOffer(): void {
		this.downloadingOffer = true;
		this.jobAPI.getLastOffer(this.jobPostId).subscribe({
			next: (response) => {
				this.offer = response;
				if (this.offer.Filename.length > 0) {
					this.getFileIcon();
				}
				this.canOffer = this.offer.JobStatus == "Live" && this.offer.AcceptOffer == null;
				this.downloadingOffer = false;
			},
			error: (err) => {
				console.log(err);
				this.downloadingOffer = false;
			}
		});
	}

	ngOnDestroy() {
		this.dialogRef.close(null);
	}

	ngOnInit(): void {
		if (this.userInfo.isAnonymous() == false) {
			this.personId = this.userInfo.getProfile().PersonId;
			this.downloadOffer();
		}
	}

	constructor(
		private dialogRef: MatDialogRef<JobPostApplicantOfferComponent>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private elementRef: ElementRef,
		private jobAPI: JS.JobPostAPIService,
		private mediaAPI: MediaAPIService,
		private renderer: Renderer2,
		private userInfo: UserInfoService
	) {
		this.jobPostId = data.jobPostId;
	}
}
